<div class="content-container mb-3">
  <div class="title mb-2">
    <mwp-text-translate text="IMPORTANT NOTICE" jsonKey="importantNotice" />
  </div>
  <div class="content">
    <div>
      {{checkoutAdminEvent.expirationInstruction}}
    </div>
    @if (checkoutAdminEvent.showGIInstruction) {
      <div class="mt-3">
        <mwp-text-translate [text]="checkoutAdminEvent.gIInstruction" jsonKey="checkoutAdminEventGIInstruction" />
      </div>
    }
    <div class="mt-3">
      <mat-checkbox [(ngModel)]="accept" [checked]="accept">
        <mwp-text-translate text="By checking this box, you certify that you have reviewed, understand, and agree to the above notifications and/or conditions." jsonKey="checkoutAdminEventCheckboxText" />
      </mat-checkbox>
    </div>
  </div>
</div>
<div>
  <mwp-benefit-enrollment-wizard-control [isContinueDisabled]="!accept" [isCheckout]="true" (emitComplete)="complete()" />
</div>